module.exports = __webpack_public_path__ + "img/5.1ae570e8.png";